<main
  class="flex-grow-1 d-flex align-items-center justify-content-center p-4 p-md-5"
>
  <div
    class="bg-white rounded-4 card-shadow w-100 overflow-hidden border border-light"
    style="max-width: 48rem"
  >
    <div class="p-4 p-md-5 text-center">
      <div class="d-flex justify-content-center mb-4">
        <div
          class="perval-bg-green bg-opacity-10 p-3 rounded-circle d-inline-flex align-items-center justify-content-center"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="92"
            height="92"
            class="primary-green"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
            />
          </svg>
        </div>
      </div>

      <h2 class="fs-2 fw-bold text-dark mb-4">
        Votre demande d'inscription a bien été prise en compte.
      </h2>

      <div class="bg-light rounded-3 p-4 mb-4 border">
        <p class="text-secondary fs-6 mb-3 fw-medium">
          Vous allez recevoir un email de validation à l'adresse <br />
          <span class="fw-bold text-dark">{{ email }}</span
          >.
        </p>

        <p class="text-secondary mb-0">
          Veuillez cliquer sur le lien
          <strong class="text-dark">"Valider"</strong>
          contenu dans cet email pour poursuivre votre inscription et pouvoir
          vous connecter sur Perval.
        </p>
      </div>

      <p class="small text-muted mb-5">
        Si vous ne recevez pas d'email d'ici quelques minutes, vérifiez votre
        dossier de courriers indésirables (spams).
      </p>

      <div class="flex justify-content-center" (click)="goHome()">
        <a
          class="perval-btn-gray text-white px-4 py-3 rounded d-inline-flex align-items-center gap-2 fw-medium"
        >
          <svg
            class="home-icon"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 20 20"
            fill="currentColor"
          >
            <path
              d="M10.707 2.293a1 1 0 00-1.414 0l-7 7a1 1 0 001.414 1.414L4 10.414V17a1 1 0 001 1h2a1 1 0 001-1v-2a1 1 0 011-1h2a1 1 0 011 1v2a1 1 0 001 1h2a1 1 0 001-1v-6.586l.293.293a1 1 0 001.414-1.414l-7-7z"
            />
          </svg>
          Retour vers la page d'accueil
        </a>
      </div>
    </div>
  </div>
</main>
